// extracted by mini-css-extract-plugin
export default {"card":"cardEmploye_card__OWqlq","cardImage":"cardEmploye_cardImage__lswne","cardName":"cardEmploye_cardName__WcUpQ","cardProfession":"cardEmploye_cardProfession__Kqf5q"};